// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-query-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Adjust as needed */
  width: 100%;
}

.admin-query-header {
  width: 100%;
  padding: 2%;
  text-align: left;
  font-weight: bold;
}

.admin-query-content {
  display: flex;
  flex: 1 1; /* Takes up full height */
  padding: 0 2%;
  gap: 2%;
}

.ad-sidebar {
  width: 30%;
  padding: 10px;
  background-color: #f8fafb;
  overflow-y: auto;
  border-radius: 10px;
  margin-bottom: 5%;
}

.chat-container {
  width: 70%;
  padding: 10px;
  background-color: #ffffff;
  overflow-y: auto;
  border-radius: 10px;
  margin-bottom: 5%;
}

.ad-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.toggle-switch {
  display: flex;
  background: #f0f0f0;
  border-radius: 20px;
  padding: 5px;
  width: 50%;
  position: relative;
  margin-bottom: 5%;
  margin-left: 25%;
  border: 2px solid #ccc;
}

.toggle-option {
  flex: 1 1;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  padding: 6px 10px;
  border-radius: 15px;
  cursor: pointer;
  color: #666;
  transition: all 0.3s ease;
}

.toggle-option.active {
  background: white;
  color: #007bff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.query-list {
  height: calc(100vh - 80px);
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 10px;
  }
}

.query-list::-webkit-scrollbar {
  display: none;
}

.query-list:hover::-webkit-scrollbar {
  display: block;
}

.query-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 2%;
  cursor: pointer;
  transition: 0.2s;
  position: relative;
  border-bottom: 2px solid #ccc;
}

.query-item:hover,
.query-item.active {
  background: #ffffff;
  border-radius: 0;
  margin: 2%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
}

.profile-pic {
  width: 40px;
  height: 40px;
  background: #ccc;
  border-radius: 50%;
  margin-right: 10px;
}

.query-info {
  flex-grow: 1;
}

.query-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.name {
  font-weight: bold;
  margin: 0;
}

.time {
  font-size: 12px;
  color: gray;
  margin: 10px;
}

.message-preview {
  color: gray;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline-block;
  margin: 0;
}

.unread-dot {
  top: 5px;
  right: 10px;
  width: 15px;
  height: 15px;
  margin: 0%;
  padding: 0;
  font-size: small;
  color: #fff;
  text-align: center;
  background-color: #0078ce;
  border-radius: 50%;
}

.message-preview.unread-message {
  color: #0078ce;
}

.query-header .name {
  flex-grow: 1;
}

/* Hide scrollbar */
.chat-messages {
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
  height: 470px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/* Hide scrollbar for WebKit (Chrome, Safari) */
.chat-messages::-webkit-scrollbar {
  display: none;
}

/* Disabled input and button styles */
.chat-input input:disabled,
.chat-input button:disabled {
  background: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
}

.message-container {
  display: flex;
  flex-direction: column;
}

.message-header {
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 14px;
  color: #555;
  text-align: left; /* Default alignment for left */
}

.message-container.right .message-header {
  text-align: right; /* Align to the right for 'You' */
}

.message-container.left .message-header {
  text-align: left; /* Align to the left for others' names */
}

.message {
  max-width: 60%;
  padding: 0.5%;
  border-radius: 10px 10px 10px 0;
  word-wrap: break-word;
  white-space: pre-wrap;
}

.left .message {
  background: #dbeafe;
  align-self: flex-start;
}

.right .message {
  background: #001f3f;
  color: white;
  align-self: flex-end;
}

.message-time {
  font-size: 12px;
  color: gray;
  display: block;
  margin-top: 5px;
}

.chat-input {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  margin-top: 2%;
}

.input-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-wrapper {
  position: relative;
  width: 100%;
}

.message-input {
  width: 100%;
  padding: 1.5% 50px 1.5% 10px; /* Reduced right padding to make room for icon and suffix */
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.attachment-suffix {
  position: absolute;
  right: 40px; /* leave space for the icon */
  top: 50%;
  transform: translateY(-50%);
  color: #333;
  font-size: 14px;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attachment-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 20px;
  z-index: 2;
}

.attachment-icon:hover {
  color: #333;
}

.submit-btn {
  background-color: #7fbd2c;
  width: 10%;
  color: white;
  border: none;
  padding: 1.5% 2%;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.1s ease,
    box-shadow 0.3s ease;
}

.submit-btn:hover {
  background-color: #68a822; /* Slightly darker */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.submit-btn:active {
  transform: scale(0.98);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.submit-btn:focus {
  outline: 2px solid #ffca28;
  outline-offset: 2px;
}

.chat-input .submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.select-query {
  text-align: center;
  margin-top: 50px;
  font-size: 18px;
  color: gray;
}

.feedback-message {
  text-align: center;
  margin-top: 10px;
}

.feedback-message .feedback {
  background-color: #f1f1f1;
  color: #333;
  padding: 10px;
  border-radius: 10px;
}

.feedback-message .feedback p {
  margin: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeQueries/AdminQuery.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,qBAAqB;EACpC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO,EAAE,yBAAyB;EAClC,aAAa;EACb,OAAO;AACT;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;;EAExC;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;IAC7B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA;EACE,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,4BAA4B,EAAE,2DAA2D;EACzF,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,6BAA6B;EAC1C,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf;wBACsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".admin-query-container {\n  display: flex;\n  flex-direction: column;\n  height: 100vh; /* Adjust as needed */\n  width: 100%;\n}\n\n.admin-query-header {\n  width: 100%;\n  padding: 2%;\n  text-align: left;\n  font-weight: bold;\n}\n\n.admin-query-content {\n  display: flex;\n  flex: 1; /* Takes up full height */\n  padding: 0 2%;\n  gap: 2%;\n}\n\n.ad-sidebar {\n  width: 30%;\n  padding: 10px;\n  background-color: #f8fafb;\n  overflow-y: auto;\n  border-radius: 10px;\n  margin-bottom: 5%;\n}\n\n.chat-container {\n  width: 70%;\n  padding: 10px;\n  background-color: #ffffff;\n  overflow-y: auto;\n  border-radius: 10px;\n  margin-bottom: 5%;\n}\n\n.ad-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.toggle-switch {\n  display: flex;\n  background: #f0f0f0;\n  border-radius: 20px;\n  padding: 5px;\n  width: 50%;\n  position: relative;\n  margin-bottom: 5%;\n  margin-left: 25%;\n  border: 2px solid #ccc;\n}\n\n.toggle-option {\n  flex: 1;\n  text-align: center;\n  font-size: 14px;\n  font-weight: bold;\n  padding: 6px 10px;\n  border-radius: 15px;\n  cursor: pointer;\n  color: #666;\n  transition: all 0.3s ease;\n}\n\n.toggle-option.active {\n  background: white;\n  color: #007bff;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.query-list {\n  height: calc(100vh - 80px);\n  overflow-y: scroll;\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: transparent;\n    border-radius: 10px;\n  }\n}\n\n.query-list::-webkit-scrollbar {\n  display: none;\n}\n\n.query-list:hover::-webkit-scrollbar {\n  display: block;\n}\n\n.query-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin: 2%;\n  cursor: pointer;\n  transition: 0.2s;\n  position: relative;\n  border-bottom: 2px solid #ccc;\n}\n\n.query-item:hover,\n.query-item.active {\n  background: #ffffff;\n  border-radius: 0;\n  margin: 2%;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);\n}\n\n.profile-pic {\n  width: 40px;\n  height: 40px;\n  background: #ccc;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n\n.query-info {\n  flex-grow: 1;\n}\n\n.query-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.name {\n  font-weight: bold;\n  margin: 0;\n}\n\n.time {\n  font-size: 12px;\n  color: gray;\n  margin: 10px;\n}\n\n.message-preview {\n  color: gray;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n  display: inline-block;\n  margin: 0;\n}\n\n.unread-dot {\n  top: 5px;\n  right: 10px;\n  width: 15px;\n  height: 15px;\n  margin: 0%;\n  padding: 0;\n  font-size: small;\n  color: #fff;\n  text-align: center;\n  background-color: #0078ce;\n  border-radius: 50%;\n}\n\n.message-preview.unread-message {\n  color: #0078ce;\n}\n\n.query-header .name {\n  flex-grow: 1;\n}\n\n/* Hide scrollbar */\n.chat-messages {\n  display: flex;\n  flex-direction: column-reverse;\n  overflow-y: auto;\n  height: 470px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n/* Hide scrollbar for WebKit (Chrome, Safari) */\n.chat-messages::-webkit-scrollbar {\n  display: none;\n}\n\n/* Disabled input and button styles */\n.chat-input input:disabled,\n.chat-input button:disabled {\n  background: #e0e0e0;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.message-container {\n  display: flex;\n  flex-direction: column;\n}\n\n.message-header {\n  font-weight: bold;\n  margin-bottom: 5px;\n  font-size: 14px;\n  color: #555;\n  text-align: left; /* Default alignment for left */\n}\n\n.message-container.right .message-header {\n  text-align: right; /* Align to the right for 'You' */\n}\n\n.message-container.left .message-header {\n  text-align: left; /* Align to the left for others' names */\n}\n\n.message {\n  max-width: 60%;\n  padding: 0.5%;\n  border-radius: 10px 10px 10px 0;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n}\n\n.left .message {\n  background: #dbeafe;\n  align-self: flex-start;\n}\n\n.right .message {\n  background: #001f3f;\n  color: white;\n  align-self: flex-end;\n}\n\n.message-time {\n  font-size: 12px;\n  color: gray;\n  display: block;\n  margin-top: 5px;\n}\n\n.chat-input {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  margin-top: 2%;\n}\n\n.input-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.message-input {\n  width: 100%;\n  padding: 1.5% 50px 1.5% 10px; /* Reduced right padding to make room for icon and suffix */\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.attachment-suffix {\n  position: absolute;\n  right: 40px; /* leave space for the icon */\n  top: 50%;\n  transform: translateY(-50%);\n  color: #333;\n  font-size: 14px;\n  pointer-events: none;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.attachment-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #666;\n  font-size: 20px;\n  z-index: 2;\n}\n\n.attachment-icon:hover {\n  color: #333;\n}\n\n.submit-btn {\n  background-color: #7fbd2c;\n  width: 10%;\n  color: white;\n  border: none;\n  padding: 1.5% 2%;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.1s ease,\n    box-shadow 0.3s ease;\n}\n\n.submit-btn:hover {\n  background-color: #68a822; /* Slightly darker */\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.submit-btn:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.submit-btn:focus {\n  outline: 2px solid #ffca28;\n  outline-offset: 2px;\n}\n\n.chat-input .submit-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.select-query {\n  text-align: center;\n  margin-top: 50px;\n  font-size: 18px;\n  color: gray;\n}\n\n.feedback-message {\n  text-align: center;\n  margin-top: 10px;\n}\n\n.feedback-message .feedback {\n  background-color: #f1f1f1;\n  color: #333;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.feedback-message .feedback p {\n  margin: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
